import logo from '../../logo.svg';
import UserTeaser from '../user/UserTeaser';
import { Link } from "react-router-dom";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PrimaryHeaderProps {
    toggleMobileMenu?: () => void;
}

export function PrimaryHeader({ toggleMobileMenu }: PrimaryHeaderProps) {
    const { t } = useTranslation();

    const role = localStorage.getItem('userRole');

    return(
        <div className="primary-header">
            <div className="left-container">
                {toggleMobileMenu && (
                    <button
                        className="hamburger-btn"
                        onClick={toggleMobileMenu}
                        aria-label="Toggle menu"
                    >
                        <i className="bi bi-layout-sidebar"></i>
                    </button>
                )}
                <Link className="nav-link" to="/dashboard"><img className="logo" alt="Task-Gen" src= {logo}/></Link>
            </div>
            <div className="center-container">
                <Navbar expand="lg">
                    <Navbar.Toggle aria-controls="primary-header-menu" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="/#/dashboard">{ t("Dashboard") }</Nav.Link>
                            <Nav.Link href="/#/users-groups">{ t("Users Groups") }</Nav.Link>
                            <Nav.Link href="/#/help">{ t("Help") }</Nav.Link>
                            { role && (role == 'admin' || role?.includes('admin')) &&
                                <NavDropdown title="Admin" id="primary-header-menu-admin">
                                    <NavDropdown.Item href="/#/admin/orgs">{ t("Organizations") }</NavDropdown.Item>
                                    <NavDropdown.Item href="/#/admin/users">{ t("Users") }</NavDropdown.Item>
                                    <NavDropdown.Item href="/#/admin/taskexamples">{ t("Task examples") }</NavDropdown.Item>
                                    <NavDropdown.Item href="/#/admin/videos">{ 'Videos' }</NavDropdown.Item>
                                    <NavDropdown.Item href="/#/admin/help">{ t("Help") }</NavDropdown.Item>
                                    <NavDropdown.Item href="/#/admin/faqs">{ t("FAQs") }</NavDropdown.Item>
                                    <NavDropdown.Item href="/#/admin/feedbacks">{ t("Feedbacks") }</NavDropdown.Item>
                                </NavDropdown>
                            }
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
            <div className="right-container">
                <UserTeaser />
            </div>
        </div>
    );
}
